/**
 * StatusSms
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {StatusSmsCollection} from '@/model/collection/StatusSmsCollection'

/* TODO: review generated class */
export class StatusSms extends Resource {
  idStatusPk: number = 0

  nome: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idStatusPk
  }
  set $id(val) {
    this.idStatusPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  /**
   * Gets a instance of a given ID of StatusSms
   */
  async getStatusSms(id: number) {
    return await Request.get(`/admin/status-sms/${id}`)
      .name('getStatusSms')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of StatusSms
   */
  async removeStatusSms() {
    return await Request.delete(`/admin/status-sms/${this.$id}`)
      .name('removeStatusSms')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of StatusSms
   */
  static async listStatusSms(params: any) {
    return await Request.get(`/admin/status-sms`, {params})
      .name('listStatusSms')
      .as(StatusSmsCollection)
      .getData()
  }

  /**
   * Persists a new instance of StatusSms. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistStatusSms() {
    return await Request.post(`/admin/status-sms`, this)
      .name('persistStatusSms')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of StatusSms to use it in a CSV file
   */
  static async listCsvStatusSms(params: any) {
    return await Request.get(`/admin/status-sms/csv`, {params})
      .name('listCsvStatusSms')
      .as(StatusSmsCollection)
      .getData()
  }
}
